import { useLocation, Link } from 'react-router-dom'
import { Icon } from '@iconify/react'
import './BottomMenu.css'

interface MenuItem {
  path: string
  label: string
  svgIcon?: string
  svgIconActive?: string
  iconifyIcon?: string
}

// EU-сервис: каталог курсов (главная) + кабинет. Без «Главная»/«Избранное».
const menuItems: MenuItem[] = [
  { path: '/', label: 'Courses', iconifyIcon: 'solar:notebook-minimalistic-linear' },
  { path: '/profile', label: 'Profile', iconifyIcon: 'solar:user-linear' },
]

const BottomMenu = () => {
  const location = useLocation()

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/'
    return location.pathname.startsWith(path)
  }

  return (
    <div className="block-bottom-menu">
      <nav className="bottom-menu">
        {menuItems.map(item => (
          <Link
            key={item.path}
            to={item.path}
            className={`bottom-menu-item ${isActive(item.path) ? 'active' : ''}`}
          >
            {isActive(item.path) && <div className="bottom-menu-indicator" />}
            {item.svgIcon ? (
              <img
                src={
                  isActive(item.path) && item.svgIconActive
                    ? item.svgIconActive
                    : item.svgIcon
                }
                alt={item.label}
                className="bottom-menu-icon"
              />
            ) : item.iconifyIcon ? (
              <Icon icon={item.iconifyIcon} width={32} height={32} />
            ) : null}
            <span className="bottom-menu-label">{item.label}</span>
          </Link>
        ))}
      </nav>
    </div>
  )
}

export default BottomMenu
